export default function handleContentAction({history, formContext, setFrequency, validate, onClose} = {}) {
  return (event) => {
    if (onClose && event.target.closest('[data-action="close"]')) {
      onClose();
      return;
    }

    const frequencyElement = event.target.closest('[data-action="setFrequency"]');
    if (setFrequency && frequencyElement) {
      const frequency = frequencyElement.getAttribute('data-frequency');
      const isAvailable = formContext?.frequencies?.some(f => f.value === frequency);
      if (frequency && isAvailable) {
        setFrequency(frequency);
        if (validate) {
          validate();
        }
      }
      return;
    }

    if (history && event.target.closest('[data-action="step1"]')) {
      history.push(`/${history.location.search}`);
    }
  };
}
